import React from "react";
import { withTranslation } from "react-i18next";

/**
 * Keeps a page that crashes from blanking the whole app: shows a message with a way out instead. `resetKey` (the
 * path) clears the error when the user goes to another page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(error, info && info.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render() {
    const { t } = this.props;
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" style={{ maxWidth: "480px", margin: "96px auto", padding: "0 16px", textAlign: "center", fontFamily: "var(--font-ui, inherit)" }}>
        <h2 style={{ margin: "0 0 8px", color: "#063e6c" }}>{t("Something went wrong on this page")}</h2>
        <p style={{ margin: "0 0 20px", color: "#56697f" }}>{t("Reload the page, or go back to your library.")}</p>
        <button type="button" className="link-button" style={{ marginRight: "16px" }} onClick={() => window.location.reload()}>
          {t("Reload")}
        </button>
        <a href="/">{t("Go to the library")}</a>
      </div>
    );
  }
}

export default withTranslation()(ErrorBoundary);
